import { useGetGroupQuery } from "generated/graphql";
// Utils
import { getBUFromLocalStorage } from "helpers/storage";

export const useGetGroupById = (groupId: string) => {
  const result = useGetGroupQuery({
    variables: {
      group: groupId,
      businessUnit: getBUFromLocalStorage(),
    },
    skip: !groupId,
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-only",
  });

  return result;
};
